import { defineMessages } from 'react-intl';

export const CUSTOMS_DOCUMENTS_HELP_URL =
  'https://help.shipstation.com/hc/en-us/articles/50888603341211-Customs-Declarations-Document-Upload';

export const messages = defineMessages({
  sectionTitle: {
    description: 'Title of the customs document upload section in shipment details',
    defaultMessage: 'Upload Customs Documents',
    id: 'Z3QL0X',
  },
  sectionAriaLabel: {
    description: 'Aria label for the customs documents expander section',
    defaultMessage: 'Customs Documents expander section',
    id: 'A/fm5M',
  },
  documentTypeLabel: {
    description: 'Label for the document type dropdown',
    defaultMessage: 'Document Type',
    id: 'LpOCNU',
  },
  documentTypePlaceholder: {
    description: 'Placeholder for the document type dropdown when no type is selected',
    defaultMessage: 'Select document type',
    id: 'm1p549',
  },
  documentTypePlaceholderAnother: {
    description: 'Placeholder for the document type dropdown when documents have already been uploaded',
    defaultMessage: 'Select another document type',
    id: 'shbphs',
  },
  uploadButton: {
    description: 'Label for the upload file button',
    defaultMessage: 'Upload File',
    id: 'Oj/gPI',
  },
  submitButton: {
    description: 'Label for the submit documents to carrier button',
    defaultMessage: 'Submit',
    id: 'xopq83',
  },
  deleteAriaLabel: {
    description: 'Aria label for the delete document button',
    defaultMessage: 'Remove {fileName}',
    id: 'qVs+MH',
  },
  previewAriaLabel: {
    description: 'Aria label for the preview document link',
    defaultMessage: 'Preview {fileName}',
    id: '8Nhqts',
  },
  statusUploaded: {
    description: 'Status badge for an uploaded document',
    defaultMessage: 'Uploaded',
    id: 'R5W7vt',
  },
  statusQueued: {
    description: 'Status badge for a queued document',
    defaultMessage: 'Queued',
    id: 'D4uuVr',
  },
  statusSent: {
    description: 'Status badge for a sent document',
    defaultMessage: 'Sent',
    id: 'BZcSOC',
  },
  statusFailed: {
    description: 'Status badge for a failed document',
    defaultMessage: 'Failed',
    id: 'ZnBR5C',
  },
  statusProcessing: {
    description: 'Status badge for a document being processed',
    defaultMessage: 'Processing',
    id: '8baEy/',
  },
  selectTypeBeforeUpload: {
    description: 'Error shown when user tries to upload without selecting document type',
    defaultMessage: 'Please select a document type before uploading.',
    id: 'g625g7',
  },
  uploadError: {
    description: 'Generic upload error message',
    defaultMessage: 'Failed to upload document. Please try again.',
    id: '5xNhl/',
  },
  carrierNotSupported: {
    description: 'Warning shown when the carrier does not support document upload',
    defaultMessage: "The carrier used for this shipment doesn't support electronic document upload.",
    id: 'J9zg97',
  },
  carrierNotSupportedWithDocs: {
    description: 'Warning shown when carrier does not support document upload but documents were already added',
    defaultMessage:
      "The carrier used for this shipment doesn't support electronic document upload. Previously submitted documents may not have been delivered.",
    id: 'dKlQ/B',
  },
  noDocumentsYet: {
    description: 'Empty state text when no documents have been uploaded yet',
    defaultMessage: 'No documents uploaded yet.',
    id: 'wljWkV',
  },
  starterDescription: {
    description: 'Description text in the starter state with an inline help link. {learnMoreLink} wraps the clickable text.',
    defaultMessage:
      'Attach additional customs paperwork. Not sure if you need to upload a document? <learnMoreLink>Customs Document Upload</learnMoreLink>',
    id: 'rp03iA',
  },
  starterLearnMoreLink: {
    description: 'Link text pointing to help article about customs document upload',
    defaultMessage: 'Customs Document Upload',
    id: 'j3n+S4',
  },
  starterUploadFileButton: {
    description: 'Button label to start the upload flow from the starter state',
    defaultMessage: 'Upload file',
    id: 'oIEMt4',
  },
  pendingDocumentsCheckbox: {
    description: 'Checkbox label for deferring document upload until after label purchase',
    defaultMessage: "I'll upload custom documents to the shipment after label purchase",
    id: '5jkRSy',
  },
  pendingDocumentsNote: {
    description: 'Note below the checkbox explaining when to upload later',
    defaultMessage: 'If tracking number is needed for document creation, upload later in Shipment Details',
    id: 'TsAzd6',
  },
  uploadSubsectionTitle: {
    description: 'Title of the customs document upload subsection in the sidebar',
    defaultMessage: 'Upload Customs Documents',
    id: 'KVMdLz',
  },
  carrierDocumentUploadNotSupported: {
    description: 'Tooltip text for warning badge when carrier does not support document upload',
    defaultMessage: "Carrier doesn't support electronic document upload",
    id: 'WWVBlw',
  },
  dropZoneTitle: {
    description: 'Heading inside the file drop zone area',
    defaultMessage: 'Select a File',
    id: 'B8dg6M',
  },
  dropZoneDragText: {
    description: 'Instructional text inside the file drop zone, precedes the Browse button',
    defaultMessage: 'Drag and drop a file or',
    id: 'BsiO7u',
  },
  dropZoneBrowse: {
    description: 'Browse button label inside the file drop zone',
    defaultMessage: 'Browse',
    id: 'OhuNmT',
  },
  dropZoneFormats: {
    description: 'Supported file formats hint below the file drop zone',
    defaultMessage: 'Supported formats: {formats}',
    id: 'niT/Ik',
  },
  statusInvalid: {
    description: 'Status badge for an invalid document',
    defaultMessage: 'Invalid',
    id: 'medtcR',
  },
  statusSending: {
    description: 'Status shown next to document while it is being sent to carrier',
    defaultMessage: 'Sending...',
    id: 'c4iUhA',
  },
  statusPendingSubmission: {
    description: 'Status shown next to document that has been queued for submission to carrier',
    defaultMessage: 'Pending submission',
    id: 'fnKh+S',
  },
  statusSubmittedToCarrier: {
    description: 'Status shown next to document after it has been submitted to carrier',
    defaultMessage: 'Submitted to carrier',
    id: 'E+R5y8',
  },
  uploadModalTitle: {
    description: 'Title of the customs document upload modal',
    defaultMessage: 'Upload Customs Documents',
    id: 'hJfInm',
  },
  uploadModalDoneButton: {
    description: 'Done button label in the upload modal',
    defaultMessage: 'Done',
    id: 'An0BLb',
  },
  uploadModalCancelButton: {
    description: 'Cancel button label in the upload modal',
    defaultMessage: 'Cancel',
    id: 'Y2YcnO',
  },
  uploadedFilesHeading: {
    description: 'Heading above the uploaded files list inside the upload modal',
    defaultMessage: 'Uploaded Files ({count})',
    id: 'TETYGT',
  },
  uploadedFilesInfoNote: {
    description: 'Info note below uploaded files explaining that documents will be sent after label creation',
    defaultMessage: 'Once the label is created, these document(s) will be sent directly to the carrier and cannot be changed or removed.',
    id: 'FIADBp',
  },
  uploadProgressLabel: {
    description: 'Percentage label shown below the progress bar during file upload',
    defaultMessage: 'Uploading... {percentage}%',
    id: 'UvPvXd',
  },
  uploadingStatus: {
    description: 'Status text shown above the progress bar while a file is being uploaded',
    defaultMessage: 'Uploading...',
    id: 'DSFnik',
  },
  postLabelReminderTitle: {
    description: 'Title of the post-label reminder modal for customs document upload',
    defaultMessage: 'Customs Documents Upload',
    id: 'q/8HBi',
  },
  postLabelReminderBody: {
    description: 'Body text of the post-label reminder modal explaining document upload options',
    defaultMessage:
      'It was indicated that additional customs documentation will be uploaded for this shipment. Upload the documents now in Shipment Details, or return later.',
    id: 'yyCGJn',
  },
  postLabelReminderDontShowAgain: {
    description: 'Button label to dismiss the post-label reminder modal permanently',
    defaultMessage: "Don't Show Again",
    id: 'iONDbn',
  },
  postLabelReminderDoThisLater: {
    description: 'Button label to dismiss the post-label reminder modal for now',
    defaultMessage: 'Do This Later',
    id: 'cJZYj5',
  },
  postLabelReminderShipmentDetails: {
    description: 'Button label to open shipment details from the post-label reminder modal',
    defaultMessage: 'Shipment Details',
    id: 'eeFUoR',
  },
  uploadDisabledTooltip: {
    description: 'Tooltip shown on the disabled Upload File button when no carrier is selected',
    defaultMessage: 'Select carrier before uploading documents (Supported by UPS & FedEx)',
    id: 'AWm8dz',
  },
  pendingDocumentsPopoverTitle: {
    description: 'Title of the info popover next to the pending documents checkbox',
    defaultMessage: 'How it works',
    id: 'oncrm4',
  },
  pendingDocumentsPopoverBody: {
    description: 'Body text of the info popover explaining the pending documents checkbox',
    defaultMessage: 'After selecting the checkbox you can upload the documents in the Shipment Details',
    id: 'uyQnjF',
  },
  documentTypesNotSupported: {
    description: 'Warning shown when uploaded documents have types not supported by the current carrier',
    defaultMessage: 'The following document type(s) are not supported by the current carrier: {types}',
    id: 'KblyNC',
  },
  preShipDocumentsHeading: {
    description: 'Heading for pre-ship order documents shown in the shipment details modal',
    defaultMessage: 'Pre-ship Documents ({count})',
    id: 'iC3dVr',
  },
  deleteDocumentConflict: {
    description: 'Error notification when trying to delete a document that is already queued or sent to carrier (409 Conflict)',
    defaultMessage: 'This document has already been submitted to the carrier and cannot be removed.',
    id: 'BJBjSi',
  },
  deleteDocumentError: {
    description: 'Generic error notification when document deletion fails',
    defaultMessage: 'Failed to remove document. Please try again.',
    id: 'HSHSzl',
  },
  refreshAriaLabel: {
    description: 'Aria label for the refresh documents button',
    defaultMessage: 'Refresh documents',
    id: 'bLOTg+',
  },
  warningBadgeLabel: {
    description: 'Warning badge text shown when carrier does not support document upload',
    defaultMessage: 'Warning',
    id: 'nPYP6n',
  },
});
